function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GrenadaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#C51918",
      fillRule: "evenodd",
      d: "M0 3h24v17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      fillRule: "evenodd",
      d: "M4.5 7.5h15v9h-15v-9Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "16",
      height: "10",
      x: "4",
      y: "7",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M4.5 7.5h15v9h-15v-9Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#23875F",
        fillRule: "evenodd",
        d: "M4.5 7.5 12 12l-7.5 4.5v-9ZM19.5 7.5 12 12l7.5 4.5v-9Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "8",
        height: "10",
        x: "12",
        y: "7",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M19.5 7.5 12 12l7.5 4.5v-9Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C51918",
        fillRule: "evenodd",
        d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "m11.947 12.985-1.553 1.077.496-1.845-1.14-1.179 1.544-.063.653-1.825.653 1.825h1.542l-1.138 1.242.57 1.736-1.627-.968Z",
        clipRule: "evenodd"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      fillRule: "evenodd",
      d: "m6.583 6.332.848-.527.89.473-.312-.848.622-.607h-.843l-.357-.891-.357.891-.843.031.623.576-.271.902Zm4.5 0 .848-.527.89.473-.312-.848.622-.607h-.843l-.357-.891-.357.891-.843.031.623.576-.271.902Zm5.348-.527-.849.527.272-.902-.623-.576.843-.031.357-.891.357.891h.843l-.622.607.311.848-.889-.473Zm-9.85 13.82.85-.526.889.473-.312-.848.622-.607h-.842l-.357-.892-.357.892-.844.031.623.576-.271.901Zm5.35-.526-.85.526.272-.901-.623-.576.844-.031.357-.892.357.892h.842l-.622.607.312.848-.89-.473Zm3.65.526.85-.526.889.473-.312-.848.622-.607h-.842l-.357-.892-.357.892-.844.031.623.576-.271.901Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C51918",
      fillRule: "evenodd",
      d: "M6.476 12.579s.404.36.624.482c.076-.287-.093-.939-.093-.939-.048-.155-.569-.435-.569-.435s-.146.492.038.892Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      fillRule: "evenodd",
      d: "M6.897 13.448s-1.038-.485-1.143-1.17c-.105-.686.118-1.778.118-1.778s1.685.383 1.8 1.205c.114.821-.267 1.337-.267 1.337s-.39-1.001-.757-1.112c0 0 0 .992.249 1.518Z",
      clipRule: "evenodd"
    })]
  })]
}));
//# sourceMappingURL=Grenada.js.map